import { render, staticRenderFns } from "./CompetencesTransversales.vue?vue&type=template&id=cf5742b0&scoped=true"
import script from "./CompetencesTransversales.vue?vue&type=script&lang=js"
export * from "./CompetencesTransversales.vue?vue&type=script&lang=js"
import style0 from "./CompetencesTransversales.vue?vue&type=style&index=0&id=cf5742b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5742b0",
  null
  
)

export default component.exports